export default __webpack_public_path__ + "static/media/waiter.f50846ef.png";